module.exports = __webpack_public_path__ + "static/media/all-inclusive.f02116e4.svg";